export default "__VITE_ASSET__tYKRiQZa__"